import React from "react";
import ReactDOM from "react-dom";
import injectTapEventPlugin from "react-tap-event-plugin";

import { composeWithDevTools } from "redux-devtools-extension";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { Provider } from "react-redux";

import createHistory from "history/createBrowserHistory";
import { ConnectedRouter, routerMiddleware } from "react-router-redux";

import reducers from "./reducers";
import Http from "./services/http";
import App from "./app/App";

import "./index.css";
import Location from "./services/location";
import Token from "./services/token";
import { authLogin } from "./app/actions";

const handleSso = store => {
  const tokenStr = Location.discoverQueryParam("token");
  try {
    const { login, password } = Token.parseSSOToken(tokenStr);
    store.dispatch(authLogin(login, password, true));
  } catch (ex) {
    alert(
      "Impossible de vous identifier, redirection vers la page de login ..."
    );
    window.location.href = "/login";
  }
};

const history = createHistory();
const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(thunk, routerMiddleware(history)))
);

Http.bind(store);

if (window.location.pathname !== "/sso") {
  injectTapEventPlugin();
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>,
    document.getElementById("root")
  );
} else {
  handleSso(store);
}



// WEBPACK FOOTER //
// ./src/index.js